// extracted by mini-css-extract-plugin
export default {"tile":"QuestionTile_tile__h1sIB","title":"QuestionTile_title__jhbEl","question":"QuestionTile_question__ybBFJ"};